import { render, staticRenderFns } from "./OnboardingVerified.vue?vue&type=template&id=4359aae6&scoped=true&"
import script from "./OnboardingVerified.vue?vue&type=script&lang=js&"
export * from "./OnboardingVerified.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingVerified.vue?vue&type=style&index=0&id=4359aae6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4359aae6",
  null
  
)

export default component.exports